import React, { useState, useEffect } from "react";
import { Button, Grid, makeStyles, TextField } from "@material-ui/core";
import { ProductService } from "../../../services/product.service";
import SearchIcon from "@material-ui/icons/Search";
import InputMask from "react-input-mask";
import styles from "../../../styles/global-styles";
import { actions } from "../../../redux/actions/alert";
import { connect } from "react-redux";
import BackDrop from "../../shared/backdrop/Backdrop";

const useStyles = makeStyles((theme) => ({
  rightButton: styles.buttonRightHeader,
  headercontainer: {
    height: 80,
    // border: "2px solid red",
  },
  subtitle: styles.subtitle,
}));

const HeaderDistributionByCodeBar = ({
  detailAlert,
  addAlert,
  productsByBarCode,
}) => {
  const classes = useStyles();

  const [barCode, setbarCode] = useState("");
  const [productsAvailable, setProductsAvailable] = useState(true);

  const handleBarCodeInput = ({ target: { value } }) => {
    setbarCode(value);
  };

  const searchProductByCodeBar = async () => {
    try {
      setProductsAvailable(false);
      const { data } = await ProductService.getAccesoryProductByParams({
        barCode,
        siteId: 1,
        inDistribution: 0,
        productSold: 0,
      });
      console.log("data length", data);
      if (data.length) {
        productsByBarCode(data);
      } else {
        addAlert({ showAlert: true });
        detailAlert({
          severity: "warning",
          message:
            "No se encontró un producto asociado a ese código de barras o no hay disponibilidad en almacén",
          time: 2800,
        });
      }
      setProductsAvailable(true);
    } catch (error) {
      addAlert({ showAlert: true });
      detailAlert({
        severity: "error",
        message: "Error en la búsqueda del producto",
        time: 2800,
      });
      setProductsAvailable(true);
    }
    setbarCode("");
  };
  return (
    <>
      <Grid
        container
        direction="row"
        justify="space-around"
        alignItems="center"
        className={classes.headercontainer}
      >
        <Grid item className={classes.subtitle}>
          Distribución Global
        </Grid>
        <Grid item>
          <InputMask
            mask="99999999999999"
            maskChar=""
            value={barCode || ""}
            onChange={(e) => handleBarCodeInput(e)}
          >
            {() => (
              <TextField
                style={{ marginRight: 10 }}
                name="barCode"
                placeholder="Código de barras"
                variant="outlined"
              />
            )}
          </InputMask>
        </Grid>
        <Grid item>
          <Button
            className={classes.rightButton}
            style={{ marginBottom: 10 }}
            disabled={!barCode.length}
            variant="contained"
            color="primary"
            endIcon={<SearchIcon color="secondary" />}
            onClick={searchProductByCodeBar}
          >
            Buscar
          </Button>
        </Grid>
      </Grid>

      {!productsAvailable && (
        <BackDrop
          style={{
            zIndex: 1,
            color: "#1C2668",
          }}
          isOpen={!productsAvailable}
        />
      )}
    </>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(null, dispatch)(HeaderDistributionByCodeBar);
